<template>
  <!-- Wordmark only: Mira Solutions has no icon yet -->
  <span class="ms-logo" :style="{ fontSize: size + 'px' }">
    <span class="ms-logo__word">Mira <span class="ms-logo__accent">Solutions</span></span>
    <span v-if="byline" class="ms-logo__byline">{{ copy[$lang].brand.byline }}</span>
  </span>
</template>

<script>
import copy from "@/locales/layout";

export default {
  name: "MiraSolutionsLogo",
  props: {
    // Font size of the wordmark in px; the byline scales with it
    size: { type: Number, default: 22 },
    byline: { type: Boolean, default: false },
  },
  data() {
    return { copy };
  },
};
</script>

<style scoped lang="scss">
.ms-logo {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25em;
  line-height: 1;
}

.ms-logo__word {
  font-family: $font-heading;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #fff;
  white-space: nowrap;
}

.ms-logo__accent {
  background: linear-gradient(135deg, $brand-magenta, $brand-pink);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ms-logo__byline {
  font-family: $font-body;
  font-size: 0.45em;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;
}
</style>
